import React from "react";
import { X } from "lucide-react";
import { ToastContainer } from "react-toastify";

const SpecialOfferModals = ({
  openModal,
  setOpenModal,

  assignOpen,
  setAssignOpen,

  editOpen,
  setEditOpen,

  deleteOpen,
  setDeleteOpen,

  form,
  setForm,

  addOffer,
  assignOffer,
  deleteOffer,

  editingOffer,
  selectedOffer,

  assignMobile,
  setAssignMobile,

  deleteId,
}) => {
  return (
    <>
    <ToastContainer/>
      {/* New Offer model */}
      {openModal && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center montserrat-font-1 z-50 p-4">
          <div className="bg-white w-full max-w-[520px] max-h-[90vh] montserrat-font-1 overflow-y-auto rounded-xl shadow-lg p-6">
            <div className="flex justify-between items-center mb-4 sticky top-0 montserrat-font-1 bg-white z-10 pb-2">
              <h2 className="text-lg font-semibold">Create New Offer</h2>

              <button
                onClick={() => setOpenModal(false)}
                className="p-2 hover:bg-gray-100 rounded-lg"
              >
                <X size={18} />
              </button>
            </div>

            <form
              className="space-y-5"
              onSubmit={(e) => {
                e.preventDefault();

                addOffer({
                  couponCode: form.couponCode,
                  offerTitle: form.offerTitle,
                  offerDescription: form.offerDescription,
                  discount: form.discount,
                  discountType: form.discountType,
                  minimumAmount: form.minimumAmount,
                  maximumDiscount: form.maximumDiscount,
                  singleUse: form.singleUse ? "Y" : "N",
                });

                setOpenModal(false);
              }}
            >
              {/* Coupon Code */}

              <div>
                <label className="block text-sm font-medium mb-1">
                  Coupon Code <span className="text-red-500">*</span>
                </label>

                <input
                  className="w-full border rounded-lg px-3 py-2 text-sm"
                  placeholder="E.g. FIRST500"
                  value={form.couponCode}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      couponCode: e.target.value.toUpperCase(),
                    })
                  }
                />
              </div>

              {/* Single Use */}

              <div>
                <label className="block text-sm font-medium mb-1">
                  Single Use Only
                </label>

                <div className="flex items-center gap-3">
                  <button
                    type="button"
                    onClick={() =>
                      setForm({ ...form, singleUse: !form.singleUse })
                    }
                    className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
                      form.singleUse ? "bg-emerald-500" : "bg-gray-300"
                    }`}
                  >
                    <span
                      className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                        form.singleUse ? "translate-x-6" : "translate-x-1"
                      }`}
                    />
                  </button>

                  <span className="text-sm text-gray-700">
                    {form.singleUse ? "Yes" : "No"}
                  </span>

                  <p className="text-xs text-gray-500">
                    If enabled, each customer can use this coupon only once.
                  </p>
                </div>
              </div>

              {/* Offer Title */}

              <div>
                <label className="block text-sm font-medium mb-1">
                  Offer Title <span className="text-red-500">*</span>
                </label>

                <input
                  className="w-full border rounded-lg px-3 py-2 text-sm"
                  placeholder="Short, clear title for this offer"
                  value={form.offerTitle}
                  onChange={(e) =>
                    setForm({ ...form, offerTitle: e.target.value })
                  }
                />
              </div>

              {/* Description */}

              <div>
                <label className="block text-sm font-medium mb-1">
                  Offer Description
                </label>

                <textarea
                  rows={3}
                  className="w-full border rounded-lg px-3 py-2 text-sm"
                  placeholder="Explain what this offer does, terms, etc."
                  value={form.offerDescription}
                  onChange={(e) =>
                    setForm({ ...form, offerDescription: e.target.value })
                  }
                />
              </div>

              {/* Discount Row */}

              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="block text-sm font-medium mb-1">
                    Discount Value <span className="text-red-500">*</span>
                  </label>

                  <input
                    className="w-full border rounded-lg px-3 py-2 text-sm"
                    placeholder="e.g. 50"
                    value={form.discount}
                    onChange={(e) =>
                      setForm({ ...form, discount: e.target.value })
                    }
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium mb-1">
                    Discount Type
                  </label>

                  <select
                    className="w-full border rounded-lg px-3 py-2 text-sm"
                    value={form.discountType}
                    onChange={(e) =>
                      setForm({ ...form, discountType: e.target.value })
                    }
                  >
                    <option value="fixed">Fixed (₹)</option>
                    <option value="percentage">Percentage (%)</option>
                  </select>

                  <p className="text-xs text-gray-500 mt-1">
                    For percentage, you can also limit discount using "Max
                    Discount".
                  </p>
                </div>
              </div>

              {/* Min / Max */}

              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="block text-sm font-medium mb-1">
                    Minimum Order Amount
                  </label>

                  <input
                    className="w-full border rounded-lg px-3 py-2 text-sm"
                    placeholder="e.g. 499"
                    value={form.minimumAmount}
                    onChange={(e) =>
                      setForm({ ...form, minimumAmount: e.target.value })
                    }
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium mb-1">
                    Maximum Discount (₹)
                  </label>

                  <input
                    className="w-full border rounded-lg px-3 py-2 text-sm"
                    placeholder="Optional"
                    value={form.maximumDiscount}
                    onChange={(e) =>
                      setForm({ ...form, maximumDiscount: e.target.value })
                    }
                  />
                </div>
              </div>

              {/* Footer */}

              <div className="flex justify-end gap-3 pt-4 border-t">
                <button
                  type="button"
                  onClick={() => setOpenModal(false)}
                  className="px-4 py-2 text-sm border rounded-lg bg-gray-100 hover:bg-gray-200"
                >
                  Cancel
                </button>

                <button
                  type="submit"
                  className="px-4 py-2 text-sm bg-emerald-500 hover:bg-emerald-600 text-white rounded-lg"
                >
                  Create Offer
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Assign Offer */}
      {assignOpen && (
        <div className="fixed inset-0 bg-black/40 flex items-center montserrat-font-1 justify-center z-50">
          <div className="bg-white w-[420px] rounded-xl montserrat-font-1 shadow-lg">
            {/* Header */}

            <div className="flex justify-between items-center p-5 border-b montserrat-font-1">
              <h2 className="text-lg font-semibold">
                Assign Offer to Customer
              </h2>

              <button
                onClick={() => setAssignOpen(false)}
                className="p-2 rounded-lg hover:bg-gray-100"
              >
                <X size={18} />
              </button>
            </div>

            {/* Body */}

            <form
              className="p-5 space-y-5"
              onSubmit={(e) => {
                e.preventDefault();

                const offerId =
                  selectedOffer?.offerid ||
                  selectedOffer?.id ||
                  selectedOffer?.pk_offer_id;

                assignOffer(offerId, `91${assignMobile}`);

                setAssignMobile("");
                setAssignOpen(false);
              }}
            >
              {/* Selected Offer */}

              <div>
                <label className="block text-sm font-medium mb-1 montserrat-font-1">
                  Selected Offer
                </label>

                <div className="text-sm text-gray-700 font-medium">
                  {selectedOffer?.coupon_code}
                </div>
              </div>

              {/* Mobile */}

              <div>
                <label className="block text-sm font-medium mb-1">
                  Customer Mobile <span className="text-red-500">*</span>
                </label>

                <input
                  className="w-full border rounded-lg px-3 py-2 text-sm"
                  placeholder="10-digit mobile number"
                  value={assignMobile}
                  onChange={(e) =>
                    setAssignMobile(
                      e.target.value.replace(/\D/g, "").slice(0, 10),
                    )
                  }
                />

                <p className="text-xs text-gray-500 mt-1 montserrat-font-2">
                  We will automatically send it as <b>91 + number</b> in the
                  API.
                </p>
              </div>

              {/* Footer */}

              <div className="flex justify-end gap-3 pt-3 border-t">
                <button
                  type="button"
                  onClick={() => setAssignOpen(false)}
                  className="px-4 py-2 rounded-lg border bg-gray-100 hover:bg-gray-200 text-sm"
                >
                  Cancel
                </button>

                <button
                  type="submit"
                  className="px-4 py-2 rounded-lg bg-emerald-500 hover:bg-emerald-600 text-white text-sm"
                >
                  Assign Offer
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* edit model */}
      {editOpen && (
        <div className="fixed inset-0 bg-black/40 flex items-center montserrat-font-1 justify-center z-50 p-4">
          <div className="bg-white w-full max-w-[720px] max-h-[90vh] montserrat-font-1 overflow-y-auto rounded-xl shadow-xl p-5">
            {/* HEADER */}
            <div className="flex justify-between items-center sticky top-0 bg-white z-[9999]">
              <h2 className="text-lg font-semibold">Edit Special Offer</h2>

              <button
                onClick={() => setEditOpen(false)}
                className="p-2 hover:bg-gray-100 rounded-lg"
              >
                <X size={18} />
              </button>
            </div>

            {/* FORM */}
            <form
              className="space-y-5"
              onSubmit={async (e) => {
                e.preventDefault();

                await addOffer({
                  offerId:
                    editingOffer?.offerid ||
                    editingOffer?.id ||
                    editingOffer?.pk_offer_id,

                  couponCode: form.couponCode,
                  offerTitle: form.offerTitle,
                  offerDescription: form.offerDescription,
                  discount: form.discount,
                  discountType: form.discountType,
                  minimumAmount: form.minimumAmount,
                  maximumDiscount: form.maximumDiscount,
                  singleUse: form.singleUse ? "Y" : "N",
                });

                setEditOpen(false);
                // fetchOffers();
              }}
            >
              {/* 2 COLUMN GRID */}
              <div className="grid grid-cols-2 gap-4">
                {/* Coupon Code */}
                <div>
                  <label className="text-sm font-medium">
                    Coupon Code <span className="text-red-500">*</span>
                  </label>
                  <input
                    className="w-full mt-1 border rounded-lg px-3 py-2"
                    value={form.couponCode}
                    onChange={(e) =>
                      setForm({
                        ...form,
                        couponCode: e.target.value.toUpperCase(),
                      })
                    }
                  />
                </div>

                {/* Single Use Toggle */}
                <div>
                  <label className="text-sm font-medium">Single Use Only</label>

                  <div className="flex items-center gap-3 mt-2">
                    <button
                      type="button"
                      onClick={() =>
                        setForm({ ...form, singleUse: !form.singleUse })
                      }
                      className={`relative inline-flex h-6 w-11 items-center rounded-full transition ${
                        form.singleUse ? "bg-emerald-500" : "bg-gray-300"
                      }`}
                    >
                      <span
                        className={`inline-block h-4 w-4 transform rounded-full bg-white transition ${
                          form.singleUse ? "translate-x-6" : "translate-x-1"
                        }`}
                      />
                    </button>

                    <span className="text-sm">
                      {form.singleUse ? "Yes" : "No"}
                    </span>
                  </div>
                </div>

                {/* Offer Title */}
                <div>
                  <label className="text-sm font-medium">
                    Offer Title <span className="text-red-500">*</span>
                  </label>
                  <input
                    className="w-full mt-1 border rounded-lg px-3 py-2"
                    value={form.offerTitle}
                    onChange={(e) =>
                      setForm({ ...form, offerTitle: e.target.value })
                    }
                  />
                </div>

                {/* Discount Value */}
                <div>
                  <label className="text-sm font-medium">
                    Discount Value <span className="text-red-500">*</span>
                  </label>
                  <input
                    className="w-full mt-1 border rounded-lg px-3 py-2"
                    value={form.discount}
                    onChange={(e) =>
                      setForm({ ...form, discount: e.target.value })
                    }
                  />
                </div>

                {/* Discount Type */}
                <div>
                  <label className="text-sm font-medium">Discount Type</label>
                  <select
                    className="w-full mt-1 border rounded-lg px-3 py-2"
                    value={form.discountType}
                    onChange={(e) =>
                      setForm({ ...form, discountType: e.target.value })
                    }
                  >
                    <option value="fixed">Fixed (₹)</option>
                    <option value="percentage">Percentage (%)</option>
                  </select>
                </div>

                {/* Minimum Amount */}
                <div>
                  <label className="text-sm font-medium">
                    Minimum Order Amount
                  </label>
                  <input
                    className="w-full mt-1 border rounded-lg px-3 py-2"
                    value={form.minimumAmount}
                    onChange={(e) =>
                      setForm({ ...form, minimumAmount: e.target.value })
                    }
                  />
                </div>

                {/* Max Discount */}
                <div>
                  <label className="text-sm font-medium">
                    Maximum Discount (₹)
                  </label>
                  <input
                    className="w-full mt-1 border rounded-lg px-3 py-2"
                    value={form.maximumDiscount}
                    onChange={(e) =>
                      setForm({ ...form, maximumDiscount: e.target.value })
                    }
                  />
                </div>
              </div>

              {/* FULL WIDTH DESCRIPTION */}
              <div>
                <label className="text-sm font-medium">Offer Description</label>
                <textarea
                  rows={3}
                  className="w-full mt-1 border rounded-lg px-3 py-2"
                  value={form.offerDescription}
                  onChange={(e) =>
                    setForm({ ...form, offerDescription: e.target.value })
                  }
                />
              </div>

              {/* FOOTER */}
              <div className="flex justify-end gap-3 pt-4 border-t">
                <button
                  type="button"
                  onClick={() => setEditOpen(false)}
                  className="px-4 py-2 rounded-lg border bg-gray-100"
                >
                  Cancel
                </button>

                <button
                  type="submit"
                  className="px-5 py-2 rounded-lg bg-emerald-500 hover:bg-emerald-600 text-white"
                >
                  Update Offer
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* delete model */}
      {deleteOpen && (
        <div className="fixed inset-0 bg-black/40 flex items-center montserrat-font-1 justify-center z-50">
          <div className="bg-white p-6 rounded-xl w-[360px]">
            <h3 className="text-lg font-semibold mb-3">Delete Offer</h3>

            <p className="text-sm text-gray-600 mb-5 montserrat-font-1">
              Are you sure you want to delete this offer?
            </p>

            <div className="flex justify-end gap-2">
              <button
                onClick={() => setDeleteOpen(false)}
                className="px-4 py-2 border rounded-lg"
              >
                Cancel
              </button>

              <button
                onClick={() => {
                  if (!deleteId) return;

                  deleteOffer(deleteId);
                  setDeleteOpen(false);
                }}
                className="px-4 py-2 bg-red-500 hover:bg-red-600 text-white rounded-lg text-sm"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SpecialOfferModals;
